import FormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';
import { rowDrawer } from './CustomDrawer.style';
export const CustomRowDrawer = ({ label, value, element, onChange, onClick }) => {
    return (React.createElement(FormControlLabel, { sx: rowDrawer, value: value, key: value, control: element, label: label, labelPlacement: "start", onChange: onChange, onClick: onClick }));
};
